var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './../../services/auth.service';
import { UserService } from './../../services/user.service';
import { AppinfoService } from './../../services/appinfo.service';
import { AzgivService } from './../../services/azgiv.service';
import { CancelTranscService } from './../../services/cancel-transc.service';
import { IdleService } from './../../services/idle.service';
import { ContentJobsService } from './../content-jobs/content-jobs.service';
import { LayerQcService } from './../../services/layer-qc.service';
import { SocketService } from './../../services/socket.service';
import { SocketProcess } from './../common-socket-msg/common-socket-msg.component';
import { IntegratorService } from 'app/services/integrator.service';
import { SocketSidekickService } from 'app/services/socket-sidekick.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { SocketErrorsModalComponent } from '../modal/socket-errors-modal/socket-errors-modal.component';
import { LayerService } from 'app/services/layer.service';
import { EnablePublishLayerService } from 'app/services/enable-publish-layer.service';
import { TransactionLogService } from 'app/services/transaction-log.service';
import { DomainService } from 'app/services/domain.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { ClearService } from 'app/services/clear.service';
import { FishboneService } from 'app/services/fishbone.service';
var AzgivComponent = /** @class */ (function () {
    function AzgivComponent(router, 
    // private stateService: StateService,
    toastr, authService, integratorService, userService, appinfoService, azgivService, cancelService, clearService, domainService, fishboneService, idleService, jobsService, layerService, qcService, reportService, modalService, socketService, socketSidekickService, enablePublishLayerService, transactionLogService) {
        this.router = router;
        this.toastr = toastr;
        this.authService = authService;
        this.integratorService = integratorService;
        this.userService = userService;
        this.appinfoService = appinfoService;
        this.azgivService = azgivService;
        this.cancelService = cancelService;
        this.clearService = clearService;
        this.domainService = domainService;
        this.fishboneService = fishboneService;
        this.idleService = idleService;
        this.jobsService = jobsService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.reportService = reportService;
        this.modalService = modalService;
        this.socketService = socketService;
        this.socketSidekickService = socketSidekickService;
        this.enablePublishLayerService = enablePublishLayerService;
        this.transactionLogService = transactionLogService;
        // @ViewChild('socketMsgPane') socketPane: CommonSocketMsgComponent;
        // Show / hide Control Pane
        this.isControlPane = true;
        // Is socket message window closed
        this.isSocketMsgClosed = true;
        // Socket processes to display in common-socket-msg component
        this.socketProcesses = []; // { id: 'test', type: 'test', status: 'Preparing', messages: ['test'], endTime: null }
    }
    AzgivComponent.prototype.onWindowUnload = function () {
        // this.socketSidekickService.sendMessage('close');
        this.socketSidekickService.disconnectSocket();
        debugger;
    };
    AzgivComponent.prototype.onPaneResizeEnd = function () {
        this.azgivService.controlPaneResizeEnd.next(null);
    };
    // Add / update a socket process in socketProcesses
    AzgivComponent.prototype.addSocketProcess = function (data, type, isPreparing) {
        // this.socketPane.show();
        // Find process by processId
        var process = this.socketProcesses.find(function (p) { return p.id === data.processId; });
        var transaction = this.transactionLogService.socketProcesses.value.find(function (t) { return t.id === data.processId; });
        // Init a new process if process doesn't exist
        if (!process) {
            process = {
                id: data.processId,
                type: type === 'TOPO' ? 'BuildingTopo' : type,
                status: isPreparing ? 'Preparing' : 'Processing',
                messages: [],
                info: data.info || {}
            };
            this.socketProcesses.unshift(process);
            // NOTE: Do not return here.
            // In case the user logs out then logs back in, when the final message is passed, it will be processed as 'Processing' if return here.
            // return;
        }
        if (!transaction) {
            transaction = {
                id: data.processId,
                type: type === 'TOPO' ? 'BuildingTopo' : type,
                status: isPreparing ? 'Preparing' : 'Processing',
                messages: [],
                info: data.info || {},
                hideMessage: false
            };
        }
        // Update the process messages, status, timestamp, etc
        if (data.isFinal) {
            if (data.isError) { // Error
                var message = data.data.errorMessage + '' + data.data.errorDetail;
                process.messages.push(message);
                transaction.messages.push({
                    message: message,
                    time: data.timeStamp,
                    type: 'err'
                });
                process.status = 'Error';
                transaction.status = 'Error';
            }
            else if (data.isCanceled) { // Cancel
                process.status = 'Canceled';
                transaction.status = 'Canceled';
            }
            else { // Success
                process.status = 'Completed';
                transaction.status = 'Completed';
            }
            // Add Timestamp
            process.endTime = data.timeStamp;
            transaction.endTime = data.timeStamp;
        }
        else {
            // Change the process status only if:
            // 1. Process's not finished (finish includes: Completed, Error, and Canceled)
            // 2. Or process is being canceld
            switch (process.status) {
                case 'Preparing': // The first message
                case 'Completed':
                case 'Error':
                case 'Canceled':
                case 'Canceling':
                    break;
                default:
                    {
                        process.status = 'Processing';
                        transaction.status = 'Processing';
                    }
            }
            // if (process.status !== 'Completed' && process.status !== 'Error' && process.status !== 'Canceled') {
            // 	process.status = 'Processing';
            // 	// TODO
            // 	// // process.status = 'Uploading';
            // 	// switch (process.type) {
            // 	// 	case 'Upload':
            // 	// 		process.status = 'Uploading';
            // 	// 		break;
            // 	// 	case 'QC':
            // 	// 		process.status = 'QCing';
            // 	// }
            // }
            if (data.dataType === 'print') {
                process.messages.push(data.data);
                transaction.messages.push({
                    type: 'info',
                    message: data.data,
                    time: data.timeStamp
                });
            }
            else if (data.dataType === 'printJson') {
                Object.keys(data.data).forEach(function (key) {
                    data.data[key].forEach(function (item) {
                        transaction.messages.push({
                            message: item.print,
                            time: item.time,
                            type: item.typ
                        });
                    });
                });
            }
        }
        var filtered = this.transactionLogService.socketProcesses.value.filter(function (t) { return t.id !== transaction.id; });
        filtered.unshift(transaction);
        this.transactionLogService.socketProcesses.next(filtered);
    };
    AzgivComponent.prototype.cancelProcess = function (processId) {
        var process = this.socketProcesses.find(function (p) { return p.id === processId; });
        // Cancel the process
        this.cancelService.cancelTransc(processId, function () {
            // Update process type as canceling
            // This should be set after cancelTransc is successfully called.
            if (process.status !== 'Completed' || 'Error') { // if process already finished, do not update status
                process.status = 'Canceling';
            }
        });
    };
    AzgivComponent.prototype.getPrintJsonErrors = function (log) {
        var errorsMessages = [];
        if (!log.socketMsg) {
            return errorsMessages;
        }
        ;
        log.socketMsg.forEach(function (i) {
            if (i.dataType === 'printJson') {
                if (!i.data) {
                    return;
                }
                Object.keys(i.data).forEach(function (cate) {
                    i.data[cate].forEach(function (m) {
                        if (m.typ === 'err') {
                            errorsMessages.push(m);
                        }
                    });
                });
            }
        });
        return errorsMessages;
    };
    AzgivComponent.prototype.showPrintJsonErrors = function (messages, processType) {
        if (messages && ((messages.qc && messages.qc.length) || (messages.upload && messages.upload.length))) {
            var modalData = {
                processType: processType,
                messages: messages
            };
            this.modalService.openModalWindow(SocketErrorsModalComponent, {
                data: modalData
            });
        }
    };
    AzgivComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // Generate uuid
                this.appinfoService.generateSessionUuid();
                this.socketService.connectSocket();
                //
                if (this.socketSidekickService.socketParam) {
                    this.socketSidekickService.connect();
                }
                this.isControlPaneSub = this.azgivService.isControlPane.subscribe(function (value) {
                    _this.isControlPane = value;
                });
                this.initProcessSub = this.socketService.onInitProcess.subscribe(function (data) {
                    if (!data.processId) {
                        _this.addSocketProcess({
                            processId: data.tempId,
                            processType: data.processType,
                            isFinal: false,
                            isError: false,
                            isCanceled: false,
                            dataType: 'print',
                            data: '',
                            timeStamp: null
                        }, data.processType, true);
                    }
                    else {
                        // Update tempId to real processId in socketProcesses
                        var process = _this.socketProcesses.find(function (p) { return p.id === data.tempId; });
                        process.id = data.processId;
                        // Update process status
                        process.status = data.status;
                        //
                        var socketProcesses = _this.transactionLogService.socketProcesses.getValue();
                        var socketProcess = socketProcesses.find(function (i) { return i.id === data.tempId; });
                        socketProcess.id = data.processId;
                        _this.transactionLogService.socketProcesses.next(socketProcesses);
                    }
                });
                this.filePostSub = this.socketService.filePostSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var customerId, logs, log, messages;
                    return __generator(this, function (_a) {
                        // Update socketProcesses
                        this.addSocketProcess(data, 'Upload');
                        // Update socketLogs
                        this.socketService.onSocketUpdate(data, this.jobsService.uploadingLogs, {
                            success: 'File uploaded.',
                            canceled: 'Uploading process canceld by user.'
                        });
                        if (data.isFinal === true) {
                            customerId = void 0;
                            if (!data.isError && !data.isCanceled) {
                                customerId = data.data.misc ? data.data.misc.customerId : null;
                                logs = this.jobsService.uploadingLogs.getValue();
                                log = logs[data.processId];
                                messages = this.getPrintJsonErrors(log);
                                this.showPrintJsonErrors({
                                    upload: messages
                                }, 'Upload');
                                // }
                            }
                            console.log('111111111111, onFinish');
                            this.jobsService.onUploadingFinish.next({ isError: data.isError, customerId: customerId });
                        }
                        return [2 /*return*/];
                    });
                }); });
                this.uploadingFinishSub = this.jobsService.onUploadingFinish.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('onUploadingFinish', data);
                                if (!(data && !data.isError)) return [3 /*break*/, 2];
                                console.log('22222222222222');
                                return [4 /*yield*/, this.layerService.getLayers()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                this.qcSocketSub = this.socketService.qcSocketSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var customerId, qcLogs, qcLog, qcMessages;
                    return __generator(this, function (_a) {
                        // Update socketProcesses
                        this.addSocketProcess(data, 'QC');
                        // Update socketLogs
                        this.socketService.onSocketUpdate(data, this.qcService.qcLogs, {
                            success: 'QC Completed.',
                            canceled: 'QC process canceled by user.'
                        });
                        if (data.isFinal === true) {
                            customerId = void 0;
                            if (!data.isError && !data.isCanceled) {
                                customerId = data.data.misc ? data.data.misc.customerId : null;
                                qcLogs = this.qcService.qcLogs.getValue();
                                qcLog = qcLogs[data.processId];
                                qcMessages = this.getPrintJsonErrors(qcLog);
                                // if (uploadProcessId) {
                                // 	const logs = this.jobsService.uploadingLogs.getValue();
                                // 	const log = logs[uploadProcessId];
                                // 	const messages = this.getPrintJsonErrors(log);
                                // 	this.showPrintJsonErrors({
                                // 		upload: messages,
                                // 		qc: qcMessages
                                // 	}, 'UploadWithQC');
                                // } else {
                                this.showPrintJsonErrors({
                                    qc: qcMessages
                                }, 'QC');
                                // }
                            }
                            this.qcService.onQcFinish.next({ isError: data.isError, customerId: customerId });
                        }
                        return [2 /*return*/];
                    });
                }); });
                this.qrSocketSub = this.socketService.qrSocketSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var qrLogs, qrLog, qrMessages;
                    return __generator(this, function (_a) {
                        // Update socketProcesses
                        this.addSocketProcess(data, 'QR');
                        // Update socketLogs
                        this.socketService.onSocketUpdate(data, this.reportService.qrLogs, {
                            success: 'QR Completed.',
                            canceled: 'QR process canceled by user.'
                        });
                        if (data.isFinal === true) {
                            if (!data.isError && !data.isCanceled) {
                                qrLogs = this.reportService.qrLogs.getValue();
                                qrLog = qrLogs[data.processId];
                                qrMessages = this.getPrintJsonErrors(qrLog);
                                this.showPrintJsonErrors({
                                    qc: qrMessages
                                }, 'QC');
                            }
                            this.reportService.onQrFinish.next({ isError: data.isError });
                        }
                        return [2 /*return*/];
                    });
                }); });
                this.fbSocketSub = this.socketService.fishboneSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var fbLogs, fbLog, qrMessages;
                    return __generator(this, function (_a) {
                        // Update socketProcesses
                        this.addSocketProcess(data, 'AnalyzeFishbone');
                        // Update socketLogs
                        this.socketService.onSocketUpdate(data, this.reportService.qrLogs, {
                            success: 'Fishbone Completed.',
                            canceled: 'Fishbone process canceled by user.'
                        });
                        if (data.isFinal === true) {
                            if (!data.isError && !data.isCanceled) {
                                fbLogs = this.fishboneService.fbLogs.getValue();
                                fbLog = fbLogs[data.processId];
                                qrMessages = this.getPrintJsonErrors(fbLog);
                                this.showPrintJsonErrors({
                                    qc: qrMessages
                                }, 'QC');
                            }
                            this.fishboneService.onFbFinish.next({ isError: data.isError });
                        }
                        return [2 /*return*/];
                    });
                }); });
                this.buildTopoSocketSub = this.socketService.buildTopoSubject.subscribe(function (data) {
                    _this.addSocketProcess(data, 'TOPO');
                    _this.socketService.onSocketUpdate(data, _this.qcService.topoLogs, {
                        success: 'Buliding Topology completed.',
                        canceled: 'Buliding Topology process canceld by user.'
                    });
                });
                this.funcsByProcessType = {
                    Upload: {
                        viewLogs: function (processId) {
                            // this.stateService.go('jobsuploadlogs', {
                            // 	processId: processId
                            // });
                            _this.router.navigate(['azgiv/jobs/upload-logs', { processId: processId }]);
                        },
                        viewData: function () {
                            // this.stateService.go('jobsfilesreview');
                            _this.router.navigate(['azgiv/review/data-view']);
                        },
                        cancel: function (processId) {
                            _this.cancelProcess(processId);
                        }
                    },
                    QC: {
                        viewLogs: function (processId) {
                            // this.stateService.go('jobsqclogs', {
                            // 	processId: processId
                            // });
                            _this.router.navigate(['azgiv/jobs/qc-logs', { processId: processId }]);
                        },
                        viewData: function () { },
                        cancel: function (processId) {
                            _this.cancelProcess(processId);
                        }
                    },
                    BuildingTopo: {
                        viewLogs: function (processId) {
                            _this.router.navigate(['azgiv/jobs/topo-logs', { processId: processId }]);
                        },
                        viewData: function () { },
                        cancel: function (processId) {
                            _this.cancelProcess(processId);
                        }
                    }
                };
                // Set idle
                this.idleService.initIdleMonitor();
                // Subscribe to user idle status change
                this.idleStatusSub = this.idleService.status.subscribe(function (status) {
                    switch (status) {
                        case 'active':
                            _this.idleService.setActive();
                            break;
                        case 'timeout':
                            _this.idleService.clearActiveTimeout();
                            _this.clearService.logout();
                            break;
                        case 'idling':
                            _this.authService.updateToken();
                            _this.authService.clearTokenUpdateInterval();
                            _this.idleService.clearActiveTimeout();
                            _this.idleService.openIdleWindow(function (result) {
                                switch (result) {
                                    case 'stay':
                                        _this.authService.setTokenUpdateInterval();
                                        _this.authService.updateToken();
                                        _this.idleService.status.next('active');
                                        break;
                                    default:
                                        _this.clearService.logout();
                                }
                            });
                    }
                });
                // Set token to renew every xxx minute.
                this.authService.updateToken();
                this.authService.setTokenUpdateInterval();
                // Store selectedCustomer to local storage
                this.selectedCustomerSub = this.userService.selectedCustomer.subscribe(function (i) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!i) return [3 /*break*/, 2];
                                // Update domain
                                console.log('xxxxxxxxx');
                                return [4 /*yield*/, this.domainService.getDomains()];
                            case 1:
                                _a.sent();
                                localStorage.setItem(this.userService.selectedCustomerItemName, JSON.stringify(i));
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                this.layerListBSSub = this.layerService.layerListBS.subscribe(function (data) {
                    if (data.publishedLayers.length > 0) {
                        _this.enablePublishLayerService.setValue(true);
                    }
                    else {
                        _this.enablePublishLayerService.setValue(false);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    AzgivComponent.prototype.ngAfterViewInit = function () {
    };
    AzgivComponent.prototype.ngOnDestroy = function () {
        this.idleStatusSub.unsubscribe();
        this.isControlPaneSub.unsubscribe();
        this.initProcessSub.unsubscribe();
        this.filePostSub.unsubscribe();
        this.uploadingFinishSub.unsubscribe();
        this.qcSocketSub.unsubscribe();
        this.qrSocketSub.unsubscribe();
        this.fbSocketSub.unsubscribe();
        this.buildTopoSocketSub.unsubscribe();
        this.selectedCustomerSub.unsubscribe();
    };
    return AzgivComponent;
}());
export { AzgivComponent };
